import React from 'react'
// @ts-ignore no types
import { Text } from '@adc/ui-adc'
import type { primitives } from '@adc/blueprint'
import { shouldShowSealedBidTreatment } from 'common/utils/privateSeller'
import AuctionDetailsTemplate, {
  MessageContentContainer,
  RegistrationButton,
} from '../template'
import { formatDateDetailed } from '../../../utils/formatters'
import { getERVRow } from './common'
import { CombinedListingType, useListingContext } from 'common/context/listing'
import { formattedVenueAddress } from '../utils'

const detailContent = (
  listing: CombinedListingType,
  isRedesignEnabled: boolean
) => {
  const details = [
    {
      label: (
        <Text color='gray' className='u-mb-2'>
          <strong>When:</strong>
          <div data-elm-id='live_auction_date'>
            {listing.auction?.auction_date
              ? formatDateDetailed(
                  listing.auction.auction_date +
                    ' ' +
                    listing.auction.start_date_time
                )
              : 'TBD'}
          </div>
        </Text>
      ),
    },
    {
      label: (
        <Text color='gray' className='u-mb-2'>
          <strong>Where:</strong>
          <div>
            <a
              data-elm-id='live_venue_link'
              href={listing.venue?.venue_url || ''}
            >
              {listing.venue?.venue_title || 'TBD'}
            </a>
          </div>
          <div data-elm-id='live_venue_address'>
            {formattedVenueAddress(listing) || 'TBD'}
          </div>
        </Text>
      ),
    },
  ]
  const ervRow = getERVRow(listing, isRedesignEnabled)
  ervRow && details.unshift(ervRow)
  return details
}

interface OfflineProps {
  featureFlags: any
  user: primitives.AuctionUser
  isRedesignEnabled: boolean
}

const Offline = ({ featureFlags, user, isRedesignEnabled }: OfflineProps) => {
  const { listing, segment } = useListingContext()

  const shouldShowSealedBidTreatmentForListing = shouldShowSealedBidTreatment({
    segment,
    featureFlags,
  })

  return (
    <AuctionDetailsTemplate
      title='Live Auction'
      primaryButton={<RegistrationButton featureFlags={featureFlags} />}
      detailContent={detailContent(listing, isRedesignEnabled)}
      messageContent={
        // this may not be needed here as it's offline and the message content container is focused on online auction related information
        <MessageContentContainer
          featureFlags={featureFlags}
          enableBidDepositRequiredMessage
          user={user}
          shouldShowSealedBidTreatment={shouldShowSealedBidTreatmentForListing}
          accountRestrictedSlot={<></>}
        />
      }
    />
  )
}

export default Offline
